import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function AddSupplier() {
    const [errorMsg, seterrorMsg] = useState('');
    const [rows, setRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [viewManu, setViewManu] = useState([]);
    const [succesMsg, setsuccessMsg] = useState('');
    const [registerFormData, setRegisterFormData] = useState({
        "name": '',
        "person": '',
        "address": '',
        "gst": '',
        "mobile": '',
        "landline": '',
        "email": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        })
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', registerFormData.name);
        formData.append('person', registerFormData.person);
        formData.append('landline', registerFormData.landline);
        formData.append('gst', registerFormData.gst);
        formData.append('mobile', registerFormData.mobile);
        formData.append('address', registerFormData.address);
        formData.append('email', registerFormData.email);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(baseUrl + 'add-supplier/', formData)
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'supplier has been added.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setRegisterFormData({
                        name: '',
                        person: '',
                        landline: '',
                        gst: '',
                        mobile: '',
                        address: '',
                        email: '',
                        status: '',
                        addedby: '',
                        ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/add-supplier/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add supplier. Please try again later.',
                    'error'
                );
            });
    };
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (viewManu.length > 0) {
            setRows(viewManu);
        }
    }, [viewManu]);
    function fetchData() {
        setIsLoading(true);
        axios.get(`${baseUrl}add-supplier/`)
            .then(response => {
                setViewManu(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-supplier/' + id)
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    const columns = [
        {field: 'id', headerName: 'Id', width: 50},
        {field: 'name', headerName: 'supplier', width: 200},
        {field: 'person', headerName: 'Person', width: 130},
        {field: 'gst', headerName: 'GST', width: 160},
        {field: 'landline', headerName: 'landline', width: 120},
        {field: 'mobile', headerName: 'Mobile', width: 120},
        {field: 'email', headerName: 'Email', width: 140},
        {field: 'address', headerName: 'Address', width: 150},
        {
            field: 'edit', headerName: 'Edit',
            renderCell: (params) => (
                <Link to={`/edit-supplier/${params.row.id}`} target="_blank" className="btn btn-warning">
                    Edit
                </Link>
            ),
            width: 80
        },
        {
            field: 'delete', headerName: 'Action',
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i></button>
            ),
            width: 80
        },
    ];
    const buttonEnable = (registerFormData.supplier != '') && (registerFormData.person != '') && (registerFormData.mobile != '')
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className='card'>
                        <h4 className='card-header text-center'>New Supplier Registration</h4>
                        <div className='card-body'>
                            <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                            {succesMsg && <p className="text-success">{succesMsg}</p>}
                            {errorMsg && <p className="text-danger">{errorMsg}</p>}
                            <form>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="supplier" className="form-label">Supplier Name</label>
                                        <input type="text" placeholder="supplier Name" className="form-control"
                                               name="name" value={registerFormData.name} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="person" className="form-label">Person</label>
                                        <input type="text" placeholder="Person" className="form-control"
                                               name="person" value={registerFormData.person} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="Mobile" className="form-label">Mobile</label>
                                        <input type="number" maxLength={10} placeholder="Mobile"
                                               className="form-control"
                                               name="mobile" value={registerFormData.mobile} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="landline" className="form-label">landline</label>
                                        <input type="number" maxLength={10} placeholder="landline"
                                               className="form-control"
                                               name="landline" value={registerFormData.landline}
                                               onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label htmlFor="gst" className="form-label">gst</label>
                                        <input type="text" maxLength={20} placeholder="gst" className="form-control"
                                               name="gst" value={registerFormData.gst} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Address" className="form-label">Address</label>
                                        <input type="text" placeholder="Address" className="form-control"
                                               name="address" value={registerFormData.address} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="email" placeholder="Email" className="form-control"
                                               name="email" value={registerFormData.email} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type="button" disabled={!buttonEnable} onClick={submitHandler}
                                                className="btn btn-success">Register
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{height: "100%", width: "100%"}}>
                <DataGrid className="mt-4"
                          sx={{
                              boxShadow: 4,
                              border: 4,
                              borderColor: 'primary.light',
                              '& .MuiDataGrid-cell:hover': {
                                  color: 'primary.main',
                              },
                          }}
                          pageSize={28}
                          rows={rows}
                          columns={columns}
                          components={{
                              Toolbar: GridToolbar,
                          }}
                          autoHeight
                />
            </div>
        </section>
    );
}
export default AddSupplier;
